// Third-party Imports
import styled from '@emotion/styled';

// Type Imports
import type { SubMenuContentProps } from '../components/vertical-menu/SubMenuContent';

const StyledSubMenuContent = styled.div<SubMenuContentProps>`
  overflow: hidden;
  z-index: 999;
  max-height: 0;
  transition: ${({ transitionDuration }) => `max-height ${transitionDuration}ms ease-in-out`};
  box-sizing: border-box;




  ${({ rootStyles }) => rootStyles};
`;

export default StyledSubMenuContent;
